// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const ROLES = {
  provider: {
    creator: "Provider:creator",
    signatory: "Provider:signatory",
  },
  distributor: {
    readOnlyDistributionPlanner: "Distributor:read_only_distribution_planner",
    distributionPlanner: "Distributor:distribution_planner",
    restrictedDistributionPlanner:
      "Distributor:restricted_distribution_planner",
    deviceManager: "Distributor:device_manager",
  },
  organization: {
    owner: "Organization:owner",
    member: "Organization:member",
    roleManager: "Organization:role_manager",
  },
  administrator: {
    browserConfigAdmin: "Administrator:browser_config_admin",
    deviceAdmin: "Administrator:device_admin",
    distributionAdmin: "Administrator:distribution_admin",
    organizationAdmin: "Administrator:organization_admin",
    promotionAdmin: "Administrator:promotion_admin",
    userAdmin: "Administrator:user_admin",
    vewdIDsManager: "Administrator:vewd_ids_manager",
  },
  moderator: {
    appIntegrator: "Moderator:app_integrator",
    contentManager: "Moderator:content_manager",
    moderator: "Moderator:moderator",
  },
  promotionManagement: {
    promotionManager: "PromotionManagement:promotion_manager",
  },
  tivo: {
    admin: "TivoApps:admin",
    provider: "TivoApps:provider",
    moderator: "TivoApps:moderator",
    preview: "TivoApps:preview",
    bizDev: "TivoApps:business_development",
  },
  tivoDevices: {
    admin: "TivoDevices:admin",
  },
};
